import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const input: SxStyle = {
  height: 'auto',
  '& textarea': {
    whiteSpace: 'pre',
    overflowX: 'auto',
  },
};
